import React from "react";
import {Form} from "semantic-ui-react";

import CustomModal from "../CustomModal";
import Snackbar from "../Snackbar";

class EditAssetsMedia extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      payload: {
        name: '',
        tags: [],
      },
      snackbar: {
        open: false,
        message: '',
        success: false,
        error: false
      },
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if(this.props.name !== nextProps.name) {
      this.setState({ payload: { name: nextProps.name || ''}});
    }
  }

  handleState = (e) => {
    const {name, value} = e.target;
    const {payload} = this.state;
    this.setState({
      payload: {
        ...payload,
        [name]: value
      }
    });
  };

  resetSnackbar = () => {
    this.setState({
      snackbar: {
        open: false,
        message: '',
        success: false,
        error: false
      }
    })
  }

  onSubmit = () => {
    const {folderID, fileID, updateFolder, updateFile, onClose, assetType} = this.props;
    const {payload: { name }} = this.state;
    if (folderID) {
      updateFolder({id: folderID, name}, assetType)
        .then(result => {
          this.setState({
            activeIndex: [0],
            selectedFolder: null,
            snackbar: {
              open: true,
              message: 'Folder Edited!',
              success: true,
              error: false
            }
          });
        })
        .catch(error => {
          this.setState({
            activeIndex: [0],
            selectedFolder: null,
            snackbar: {
              open: true,
              message: error.data && error.data.message,
              success: false,
              error: true
            }
          });
        }).finally(onClose);
    } else if (fileID) {
      updateFile({id: fileID, name}, assetType)
        .then(result => {
          this.setState({
            activeIndex: [0],
            selectedFolder: null,
            snackbar: {
              open: true,
              message: 'File Edited!',
              success: true,
              error: false
            }
          });
        })
        .catch(error => {
          this.setState({
            activeIndex: [0],
            selectedFolder: null,
            snackbar: {
              open: true,
              message: error.data && error.data.message,
              success: false,
              error: true
            }
          });
        }).finally(onClose);
    }
  }

  render() {
    const {payload: {name}, snackbar} = this.state;
    const {open, onClose, fileLoading, folderLoading} = this.props;
    return <>
      <CustomModal
        open={open}
        onClose={onClose}
        footer={true}
        title='Edit Media'
        onSubmit={this.onSubmit}
        submitLoader={fileLoading || folderLoading}
      >
        <Form>
          <Form.Field>
            <label>Name</label>
            <Form.Input
              fluid
              id="name"
              value={name}
              onChange={this.handleState}
              name="name"
              placeholder="Name"
            />
          </Form.Field>
        </Form>
      </CustomModal>
      <Snackbar
        open={snackbar.open}
        message={snackbar.message}
        error={snackbar.error}
        success={snackbar.success}
        onClose={this.resetSnackbar}
      />
    </>
  }
}

export default EditAssetsMedia;
